module.exports = __webpack_public_path__ + "static/media/evoenergy.826d5f7d.png";